<!--多选接口控制分页界面-->
<template>
	<div class="infoListBody" @click.stop="selectStatus = false">
		<div class="infolist-out-table-box custom-scrollbar">
			<table cellpadding="0" cellspacing="0">
				<tr>
					<th style="width: 36px;" v-if="showSelection">
						<img class="icon" :src="getCheckIcon('all')" @click.stop="checkItem('all')" />
					</th>
					<th v-for="(column, r) in columns" :key="r">{{column.name}}</th>
				</tr>
				<tr v-for="(item, l) in dataList" :key="item.id">
					<td class="selection" v-if="showSelection">
						<img class="icon" :src="getCheckIcon(item)" @click.stop="checkItem(item)" />
					</td>
					<template v-for="(column,r) in columns">
						<td :key='r' v-if='column.type=="slot"'>
							<slot :name="column.key" :item='item'>
								
							</slot>
						</td>
						<td v-else :key="r">{{getLabel(l,column,r)}}</td>
					</template>
				</tr>
			</table>
		</div>
		<div ref="foot">
			<div class="pagingContainer">
				<span class="totalSize">共{{totalSize}}条</span>
				<div class="pageSize">
					<span @click.stop="selectStatus = !selectStatus">{{pageSize}} 条/页</span>
					<ul class="pageSizeSelect" ref="pageSizeSelect" v-show="selectStatus">
						<li v-for="(item, index) in pageSizeList" :key="'pageIndex'+index" 
						:class="{'nowPageSize':pageSize == item.value}" 
						@click.stop="pageSizeSelect(item)">{{item.name}}</li>
					</ul>
				</div>
				<span class="pagingBtn" :class="{'pagingBtnDisabled':pageIndex <= 1}" @click="firstPage">首页</span>
				<span class="pagingBtn" :class="{'pagingBtnDisabled':pageIndex <= 1}" @click="prePage">上一页</span>
				<span class="nowPageNum">{{pageIndex}}</span>
				<span class="pagingBtn" :class="{'pagingBtnDisabled':pageIndex >= maxPageIndex}" @click="nextPage">下一页</span>
				<span class="pagingBtn" :class="{'pagingBtnDisabled':pageIndex >= maxPageIndex}" @click="lastPage">末页</span>
			</div>
		</div>
	</div>
</template>

<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		components: {},
		/**
		 * 
		 */
		props: {
			columns: {
				type: Array,
				default () {
					return []
				}
			},
			dataList: {
				type: Array,
				default () {
					return []
				}
			},
			fillAll: {
				type: Boolean,
				default: false
			},
			getIdMethod: {
				type: Function,
				default (item) {
					return item.id != undefined ? item.id : -1
				}
			},
			showSelection: {
				type: Boolean,
				default () {
					return true
				}
			}
		},
		data() {
			return {
				totalSize: 0,
				pageSize: 20,
				pageIndex: 1,
				nowAllSelected: false,
				nowSelectIds: {},
				selectStatus: false,
				pageSizeList: [{name:'20 条/页',value:20},{name:'30 条/页',value:30},{name:'50 条/页',value:50},{name:'100 条/页',value:100}]
			}
		},
		created() {},
		mounted() {
			
		},
		destroyed() {
			
		},
		computed: {
			maxPageIndex() {
				//根据长度计算出来的最大页码
				try {
					if (this.totalSize <= 0) {
						return 0
					}
					return Math.ceil(this.totalSize / this.pageSize)
				} catch (e) {
					return 0
				}
			},
			getCheckIcon() {
				return nItem => {
					if(nItem == 'all'){
						return resourcesStore.getters.getResourcesByName('/checkBox/' + (this.nowAllSelected ? 'icon_checked.png' : 'icon_uncheck.png'))
					}else{
						return resourcesStore.getters.getResourcesByName('/checkBox/' + (this.nowSelectIds[this.getIdMethod(nItem)] ==
								true ? 'icon_checked.png' : 'icon_uncheck.png'))
					}
				}
			},
		},
		watch: {
			dataList(nv,ov){
				//切换的时候清除选中
			},
		},
		methods: {
			checkItem(item){
				if(item == 'all'){
					this.nowAllSelected = !this.nowAllSelected
					this.dataList.forEach(item => {
						this.$set(this.nowSelectIds, item.id, this.nowAllSelected)
					})
				}else{
					this.$set(this.nowSelectIds, item.id, !this.nowSelectIds[item.id])
					for(var i = 0;i < this.dataList.length;i++){
						if(!this.nowSelectIds[this.dataList[i].id]){
							this.nowAllSelected = false
							return
						}
					}
					this.nowAllSelected = true
				}
			},
			getLabel(index, column, columnIndex) {
				//获取第l行第r格的内容
				if (this.dataList[index] == undefined) {
					return ''
				}
				var data
				if (this.dataType == 1) {
					//数组型数据
					data = this.dataList[index][columnIndex]
				} else {
					//默认键值对型数据
					data = this.dataList[index][column.key]
				}
				if (column.format != undefined) {
					//数据需要经过处理
					return column.format(data,this.dataList[index])
				}
				return data
			},
			getTdStyleMethod(column, index, value) {
				var sty = {
					'overflow': 'hidden',
					/*超过部分不显示*/
					'text-overflow': 'ellipsis',
					/*超过部分用点点表示*/
					'white-space': 'nowrap',
					/*不换行*/
				}
				if (column.getTdStyleMethod != undefined) {
					try {
						Object.assign(sty, column.getTdStyleMethod(column, index, value))
					} catch (e) {
						err(e.stack)
					}
				}
				return sty
			},
			firstPage() {
				if(this.pageIndex <= 1){
					return
				}
				this.pageIndex = 1
				this.$emit('jumpToPage', 1)
			},
			prePage() {
				if(this.pageIndex <= 1){
					return
				}
				this.pageIndex--
				this.$emit('jumpToPage', this.pageIndex)
			},
			nextPage() {
				if(this.pageIndex >= this.maxPageIndex){
					return
				}
				this.pageIndex++
				this.$emit('jumpToPage', this.pageIndex)
			},
			lastPage() {
				if(this.pageIndex >= this.maxPageIndex){
					return
				}
				this.pageIndex = this.maxPageIndex
				this.$emit('jumpToPage', this.maxPageIndex)
			},
			pageSizeSelect(item) {
				this.pageIndex = 1
				this.pageSize = item.value
				this.selectStatus = false
				this.$emit('pageSizeChange', item.value)
			},
			
		}
	}
</script>

<style scoped>
	table{
		min-width: 100%;
		width: auto;
		overflow: hidden;
		table-layout: fixed;
		background-color: #FFFFFF;
	}
	
	tr:hover{
		background-color: #F2F2F2;
	}
	
	th,td{
		border-bottom: solid 1px #DCDFE6;
		padding: 4px 0;
	}
	
	td{
		text-align: center;
		min-width: 120px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow:ellipsis;
	}
	
	td.selection{
		min-width: 36px;
	}
	
	th>img,td>img{
		width: 16px;
		height: 16px;
		margin-top: 4px;
	}
	
	.pagingContainer{
		min-width: 500px;
		display: flex;
		padding: 10px;
		justify-content: flex-end;
		align-items: center;
	}
	
	.totalSize{
		margin-right: 10px;
	}
	
	.pageSize{
		display: inline-block;
		border: solid 1px #E4E4E4;
		padding: 4px 0;
		height: 20px;
		width: 80px;
		border-radius: 4px;
		text-align: center;
		position: relative;
	}
	
	.pageSizeSelect{
		position: absolute;
		width: 80px;
		top: -120px;
		left: 0;
		border: solid 1px #E4E4E4;
		border-radius: 4px;
		background-color: #FFFFFF;
		overflow: hidden;
	}
	
	.pageSizeSelect>li{
		line-height: 28px;
		border-bottom: solid 1px #E4E4E4;
	}
	
	.nowPageSize{
		background-color: #409EFF;
		color: #FFFFFF;
	}
	
	.pagingBtn{
		display: inline-block;
		padding: 4px 10px;
		margin: 10px;
		background-color: #409EFF;
		border-radius: 4px;
		color: #FFFFFF;
		cursor: pointer;
	}
	
	.pagingBtnDisabled{
		background-color: #CCCCCC;
	}
	
	.nowPageNum{
		color: #409EFF;
		display: inline-block;
		padding: 3px 10px;
		border-radius: 4px;
		border: solid 1px #E4E4E4;
		border-radius: 4px;
	}
	
	.nowPageNum:hover{
		background-color: rgba(064,158,255,0.5);
		color: #FFFFFF;
	}
	
	.infoListBody{
		background: #FCFCFC;
	}
	
	.infolist-out-table-box {
		width: calc(100% - 2px);
		height: 100%;
		overflow-x: auto;
		overflow-y: hidden;
	}
	
	.custom-scrollbar::-webkit-scrollbar {
		width: 10px;
		height: 10px;
	}
</style>